export default __webpack_public_path__ + "static/media/iconfinder_badge-css-3_317756.74d7bcc1.svg";